export const termsOfService = 'https://www.umore.app/terms-of-service-providers'
export const privacyPolicy = 'https://www.umore.app/privacy-policy-providers'
export const businessAssociateAgreement = 'https://www.umore.app/ba-agreement-providers'
export const bookADemoLink = 'https://meetings-eu1.hubspot.com/alejandro-saunders'
export const umoreTutorialLink = 'https://www.umore.app/tutorials'
export const appDeepLink = `${window.location.origin}/deep-link`
export const googlePlayLink = 'https://play.google.com/store/apps/details?id=app.umore.app&hl=en_US'
export const appStoreLink = 'https://itunes.apple.com/us/app/id1567361576?mt=8'
export const uMoreIndividualsLink = 'https://www.umore.app/individuals'
export const uMorePricingLink = 'https://www.umore.app/pricing'

export const hubSpotMonthlyPaymentLinkUSD =
  'https://app-eu1.hubspot.com/payments/qXw6JswDSS9Qc?referrer=PAYMENT_LINK'
export const hubSpotMonthlyFreeTrialPaymentLinkUSD =
  'https://app-eu1.hubspot.com/payments/ctMtjkhJSWj?referrer=PAYMENT_LINK'
export const hubSpotMonthly30DaysTrialPaymentLinkUSD =
  'https://app-eu1.hubspot.com/payments/qNNw4NFvg2?referrer=PAYMENT_LINK'

export const hubSpotMonthlyPaymentLinkEUR =
  'https://app-eu1.hubspot.com/payments/dGSQTHcZ?referrer=PAYMENT_LINK'
export const hubSpotMonthlyFreeTrialPaymentLinkEUR =
  'https://app-eu1.hubspot.com/payments/hgJ9vqxZ?referrer=PAYMENT_LINK'
export const hubSpotMonthly30DaysTrialPaymentLinkEUR =
  'https://app-eu1.hubspot.com/payments/2pfqMvz7PbJRr9?referrer=PAYMENT_LINK'

export const hubSpotMonthlyPaymentLinkGBP =
  'https://app-eu1.hubspot.com/payments/pPVr992j?referrer=PAYMENT_LINK'
export const hubSpotMonthlyFreeTrialPaymentLinkGBP =
  'https://app-eu1.hubspot.com/payments/vYKrjmYG?referrer=PAYMENT_LINK'
export const hubSpotMonthly30DaysTrialPaymentLinkGBP =
  'https://app-eu1.hubspot.com/payments/KY7VMWVvykfxJyf?referrer=PAYMENT_LINK'

export const hubSpotYearlyPaymentLink =
  'https://app-eu1.hubspot.com/payments/XQ4CkpDk?referrer=PAYMENT_LINK'
export const hubSpotYearlyFreeTrialPaymentLink =
  'https://app-eu1.hubspot.com/payments/VMHqfSdkqWTcG?referrer=PAYMENT_LINK'

export const hubSpotContactUsForm = 'https://share-eu1.hsforms.com/1Utx6xKoGT1KMxSyK0m4ubAg2r6u'
export const hubSpotMoreFeeOptionsForm =
  'https://share-eu1.hsforms.com/16GOWlfnsTj61cy0hY9PO4Qg2r6u'
